import { render, staticRenderFns } from "./TransferSyllablesSchoolPreparingPreview.vue?vue&type=template&id=f23c550a&lang=pug&"
import script from "./TransferSyllablesSchoolPreparingPreview.vue?vue&type=script&lang=js&"
export * from "./TransferSyllablesSchoolPreparingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports